import PropTypes from 'prop-types';
import { Container } from './styles';
import { ChangeEvent } from 'react';

interface InputSearchInterface {
  searchTerm: string;
  handleChangeSearchTerm: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
}

export default function InputSearch({ searchTerm, handleChangeSearchTerm, placeholder }: InputSearchInterface) {
  return (
    <Container>
      <input
        value={searchTerm}
        type="text"
        placeholder={placeholder}
        onChange={handleChangeSearchTerm}
      />
    </Container>
  );
}

InputSearch.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  handleChangeSearchTerm: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
};
